<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Upload Certifications</div>
          <div class="panal-body">
            <form>
               <div class="form-group">
                <div class="form-row">
                  <div class="col-6">
                    <label>File Type</label>
                    <select class="form-control" v-model="FileAttachmentsTypeID">
                      <option>Choose</option>
                     <option v-for="cert in CertificationFileAttachment" :value="cert.serial" v-bind:key="cert.serial"> {{cert.CertificationFileTypeEN}}</option>
                    </select>


                  </div>
                  <div class="col-6">
                    <label>Select Equivalent type</label>
                    <select class="form-control" v-model="EquilivantExamSerial">
                      <option>Choose</option>
                    <option v-for="equiv in EquivalentExamTypes" :value="equiv.Serial" v-bind:key="equiv.Serial"> {{equiv.EqExamEn}}</option>
                    </select>


                  </div>

                  <div class="col-6">
                    <label>Upload</label>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="customFile" ref="file" v-on:change="handleFileUpload()">
                      <label class="custom-file-label" for="customFile">{{file.name ? file.name : "Choose file"}}</label>
                      <progress max="100" :value.prop="uploadPercentage"></progress>
                    </div>

                  </div>


                  <div class="text-right col-12 mt-3">
                    <button type="button" class="btn btn-primary mr-1" @click="submitFile" :disabled="submitted">Submit</button>
                    <button type="reset" class="btn btn-success" @click="Cancel">Cancel</button>

                  </div>
                </div>
              </div>

            </form>



   <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>



          </div>

        </div>
      </div>
    </div>
  </div>



</template>

<script>
import ApplicantService from '../../services/Applicant/Applicant.service'
import Axios from 'axios'
import { API_URL } from '../../services/API_URL'
export default {
  data(){
    return{
            submitted:false,
            loading: false,
            successful: false,
            message:'',
            CertificationFileAttachment:[],
            EquivalentExamTypes:[],
            file: '',
            uploadPercentage: 0 ,
            FileAttachmentsTypeID : '' ,
            EquilivantExamSerial:''

    }
  },
  mounted(){
      ApplicantService.GetAllCertificationFileAttachment().then(Response =>{
          this.CertificationFileAttachment=Response.data
        }, error => {
             this.seuccess =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            }),
            ApplicantService.GetAllEquivalentExamTypes().then(Response =>{
          this.EquivalentExamTypes=Response.data
        }, error => {
             this.seuccess =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            })
  },
  computed:{
    currenUser(){
            return  this.$store.state.auth.user
          }
  },
  methods:{
     Cancel() {
          
      this.$emit('clicked', this.selected = 0 )
    },
    handleFileUpload(){
 this.file = this.$refs.file.files[0];
},
submitFile(){

  this.submitted =true
  /*
    Initialize the form data
  */
  let formData = new FormData();

  /*
    Add the form data we need to submit
  */
  let ExamID = localStorage.getItem('examId')
  formData.append('UploadedFile', this.file);
  formData.append('FileAttachmentsTypeID', this.FileAttachmentsTypeID)
  formData.append('EquivalentExamID',this.EquilivantExamSerial )
  formData.append('UserID', this.currenUser.UserIDSerial)
  formData.append('ApplicantExamID',ExamID )

// eslint-disable-next-line no-console
console.log(this.FileAttachmentsTypeID+'-'+this.EquilivantExamSerial +'-'+this.currenUser.UserIDSerial+'-'+ExamID)
  /*
    Make the request to the POST /single-file URL
  */
 
   Axios.post( API_URL+'/Exams/UpdateEquivalentExam',
    formData,
    {
      headers: {
          'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: function( progressEvent ) {
        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
      }.bind(this)
    }
  ).then(error=>{
    this.submitted =true
     this.successful =true
      this.message = error.data
                /*eslint-disable-next-line*/
    console.log('SUCCESS!!',error);
    setTimeout(3000,this.Cancel())
  })
  .catch(error =>{
                /*eslint-disable-next-line*/
           console.log('FAILURE!!',error);
           
              this.empty = false ;
              this.successful =false
this.submitted =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.Message ||
                error.toString();
            
  });

}
  }
}
</script>

<style scoped>
  table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    color: #333;
    font-weight: bold;
  }

  .panal {
    background: #fff;
    border-radius: 10px;
    color: #fff;
    padding: 0px 0px 20px 0px;
    margin: 10px 0;

  }

  .panal-header {
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
    width: 50%;
    /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
  }

  .panal-body {
    padding: 20px;
    color: #333;
  }

  .app-stu-photo {
    float: right;
    width: 200px;
    border-radius: 10px;
    border: 1px solid #111;
    margin-top: 20px;
  }

  .app-stu-photo img {
    width: 100%;
    border-radius: 10px;

  }

  .app-All {
    width: 80%;
    float: left;
  }

  .app-stu {
    border-bottom: 1px #333 dotted;
    padding: 10px 0px;

  }

  .app-stu .title {
    font-weight: bold;

  }

  .app-stu .title span {
    font-weight: 100;



  }

  .table .thead-dark th {
    color: #fff;
    background-color: #dee2e6 !important;
    border-color: #989899 !important;
  }

  @media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>